export * from './error.component';